import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import { useLocation } from 'react-router-dom';

import { layout, } from 'styles';
import IsLogged from 'common/components/IsLogged';
import HasAccess from 'common/components/HasAccess';
import ShoppingCart from '../ShoppingCart';
import { USER_PANEL_TYPES, UserPanelItem, } from './index';

const UserPanelContainer = () => {
    const { root, } = layout.makeUserPanelStyles();
    const location = useLocation();
    const isCheckout = Boolean(location?.pathname.match('/checkout'));

    return (
        <IsLogged>
            <div className={root}>
                <HasAccess>
                    {isCheckout ? null : <ShoppingCart/>}
                </HasAccess>
                <Hidden smDown>
                    <UserPanelItem type={USER_PANEL_TYPES.USER_ACTION}/>
                    <UserPanelItem type={USER_PANEL_TYPES.USER_LINK}/>
                </Hidden>
            </div>
        </IsLogged>
    );
};

export default UserPanelContainer;
